import { useContext, useEffect, useRef, useState } from "react";
import { GridLayout, HorizontalLayout, HorizontalPageLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { ProjectComp } from "../components/ProjectComp";
import { TitleAction } from "../molecule/TitleAction";
import { Alert } from "../components/alert";
import { deleteAPI, fetchAPI, getAPI, postAPI } from "../api/api";
import { CreateProjectModal, FaseModal } from "../components/customModals";
import { IconButton } from "../atoms/buttons";
import { CourseComp, IconText } from "../components/courseComp";
import { StandardComp } from "../atoms/standardComp";
import { PageContext, UserContext } from "../App";
import { TitleDescriptionText } from "../atoms/titleDescription";
import { TextAtom } from "../atoms/TextAtom";

import { Campaign, HeaderCampagne } from "../components/campagne";

export function Project({ pageSwap }) {
  const [projects, setProjects] = useState([]);
  const [campagnes, setCampagnes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProjectDetail, setSelectedProjectDetail] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showFaseModal, setFaseModal] = useState(false);
  const [activeModal, setActiveModal] = useState("");
  const [activeTitle, setActiveTitle] = useState("");
  const [stepId, setStepId] = useState(null);
  const [pageType, setPageType] = useState(true);
  const userInformation = useContext(UserContext);
  const isPublic = userInformation.account_type === 1;
  const [dates, setDates] = useState({ start: null, end: null });
  const [isEditable, setIsEditable] = useState(false);


  
  const LoadProject = async () => {
    setLoading(true);
    const query = "api/workflows";
    const res = await fetchAPI(query);
    setProjects(Array.isArray(res) ? res : []);
    setLoading(false);
    return res;
  };

    const LoadCampagnes = async () => {
    setLoading(true);
    const query = "api/campagne";
    const res = await fetchAPI(query);
    setCampagnes(Array.isArray(res) ? res : []);
    setLoading(false);
    return res;
  };

  const loadProjectDetail = async (id_project) => {
    const query = `api/workflows/${id_project}`;
    const res = await fetchAPI(query);
    console.log("workflowRes",res)
    setSelectedProjectDetail(res);
  };

  const loadCampagneDetail = async (id_campagne) => {
    const query = `api/campagne/${id_campagne}`;
    const res = await fetchAPI(query);
    setSelectedProjectDetail(res);
  };

  const removeCourse = async (selectedCourse, stepId) => {
    const query = isPublic ? `api/campagne/remove-course` : `api/workflows/remove-course`;
    const body = {
        id_step: stepId,
        id_course: selectedCourse
      };

    const res = await deleteAPI(query, body);
      if (res.status === "ok") {
        await (isPublic
          ? (async () => {
              await LoadCampagnes();
              setFaseModal(false);
              await loadCampagneDetail(selectedProjectDetail[0].id_campagne);
            })()
          : (async () => {
              await LoadProject();
              setFaseModal(false);
              await loadProjectDetail(selectedProjectDetail[0].id_workflow);
            })()
        );
      }
        
    };

  const refresh = () => {
    return(
      isPublic 
      ?
      (LoadCampagnes(), loadCampagneDetail(selectedProjectDetail[0].id_campagne))
      : 
      (LoadProject(), loadProjectDetail(selectedProjectDetail[0].id_workflow))
    )
  }

  const createWorkflow = async ({ project_name, description, status }) => {
    const body = { project_name, description, status };
    const query = `api/workflows/create`;
    const res = await postAPI(query, body);
      if (res.status === "ok") {
        await LoadProject();
      }
  };

  const createCampagne = async ({ campagne_name, description, status }) => {
    const body = { campagne_name, description, status };
    const query = `api/campagne/create`;
    const res = await postAPI(query, body);
      if (res.status === "ok") {
        await LoadCampagnes();
      }
  };

  const handleTitleUpdate = async (newTitle) => {
    const workflowId = selectedProjectDetail?.[0].id_workflow
    const campagneId = selectedProjectDetail?.[0].id_campagne
    const body = isPublic ? { campagneId, newTitle } : { workflowId, newTitle }
    const query = isPublic ? `api/campagne/update-name` : `api/workflows/update-name`;
    const res = await postAPI(query, body);
    if (res.status === "ok") {
            LoadCampagnes();
            LoadProject();
      await loadProjectDetail(workflowId);
    }
  };

  useEffect(() => {
    LoadProject();
    LoadCampagnes();
  }, []);
  const backUpName = isPublic ? "Campagnes" : "Workflows"
  const projectName = selectedProjectDetail?.[0]?.projectName || backUpName;

  const today = new Date().toISOString().split("T")[0];

  const handleWorkflowRemoved = async () => {
        setSelectedProjectDetail(null);

        {isPublic? await LoadCampagnes() : await LoadProject()}
  }

  const formatDisplayDate = (isoDate) => {
    if (!isoDate) return "";
    const [y, m, d] = isoDate.split("-");
    return `${d}-${m}-${y}`;
  };
  const handleEdit = () => {
    if (selectedProjectDetail === null) {
        return false;
    }
    return true;
  }

  return (
    <>
      <VerticalPageLayout
        className={`project-page page-in-animation ${pageSwap ? "page-out-animation" : ""}`}
        style={{ alignItems: "unset", overflowX: "hidden" }}
      >
        {isPublic ? (
                  <>
                  <HeaderCampagne
                    selectedProjectDetail={selectedProjectDetail}
                    setSelectedProjectDetail={setSelectedProjectDetail}
                    LoadCampagnes={LoadCampagnes}
                    setActiveModal={setActiveModal}
                    setFaseModal={setFaseModal}
                    setActiveTitle={setActiveTitle}
                    setShowCreateModal={setShowCreateModal}
                    projectName={projectName}
                    handleEdit={handleEdit}
                    handleTitleUpdate={handleTitleUpdate}
                  />
                    {campagnes.length === 0 && !loading && (
                      <Alert
                        className="standard-margin"
                        type="warning"
                        title="Geen campagnes"
                        message="Er zijn nog geen campagnes beschikbaar. Gebruik de knop 'stel je campagne samen' om een nieuw campagne aan te maken."
                      />
                    )}

                    {!selectedProjectDetail && (
                      <ProjectComp
                      projects={campagnes}
                      onSelectProject={loadCampagneDetail}
                      />
                    )}

                  </>
            ) : (
              <>
                   <TitleAction
                      goBack={selectedProjectDetail ? () => { setSelectedProjectDetail(null); LoadProject(); } : undefined}
                      onClick={selectedProjectDetail
                              ? () => {
                                  setActiveModal("delete");
                                  setFaseModal(true);
                                  setActiveTitle(`${isPublic ? "Campagne" : "Workflow"} verwijderen`);
                                }
                              : () => {
                                  setShowCreateModal(true);
                                  setActiveTitle(`Stel je ${isPublic ? "campagne" : "workflow"} samen`);
                                }}
                      title={projectName}
                      buttonTitle={selectedProjectDetail ? `${isPublic ? "Campagne" : "Workflow"} verwijderen` : `Stel je ${isPublic ? "campagne" : "workflow"} aan`}
                      editable={handleEdit}
                      onRename={handleTitleUpdate}
                    />

                    {projects.length === 0 && !loading && (
                      <Alert
                        className="standard-margin"
                        type="warning"
                        title="Geen projecten"
                        message="Er zijn nog geen projecten beschikbaar. Gebruik de knop '+ project' om een nieuw project aan te maken."
                      />
                    )}

                    {!selectedProjectDetail && (
                      <ProjectComp
                        projects={projects}
                        onSelectProject={loadProjectDetail}
                      />
                    )}

              </>
                      )}

        {selectedProjectDetail && isPublic ? (
          <>
            <Campaign
              selectedCampagneDetail={selectedProjectDetail}
              setFaseModal={setFaseModal}
              setActiveModal={setActiveModal}
              setstepId={setStepId}
              removeCourse={removeCourse}
              formatDisplayDate={formatDisplayDate}
              pageType={pageType}
              today={today}
              setdates={setDates}
              isPublic={isPublic}
              setActiveTitle={setActiveTitle}
            />
            <CreateProjectModal
              visible={showCreateModal}
              onWorkflowRemoved={handleWorkflowRemoved}
              dismiss={() => { setShowCreateModal(false); }}
              position="center"
              onSave={isPublic ? createCampagne  : createWorkflow }  
            />
        </>
        ) : (
          <>          
            <Workflows
              selectedProjectDetail={selectedProjectDetail}
              setFaseModal={setFaseModal}
              setActiveModal={setActiveModal}
              setstepId={setStepId}
              removeCourse={removeCourse}
              formatDisplayDate={formatDisplayDate}
              pageType={pageType}
              today={today}
              setdates={setDates}
            />
            <CreateProjectModal
            visible={showCreateModal}
            dismiss={() => setShowCreateModal(false)}
            position="center"
            onSave={isPublic ? createCampagne : createWorkflow }
            />
          </>
           )}
      </VerticalPageLayout>

      {showFaseModal && selectedProjectDetail && (
        <FaseModal
          visible={showFaseModal}
          type={activeModal}
          title={activeTitle}
          project={selectedProjectDetail}
          dateRanges={dates}
          dismiss={() => setFaseModal(false)}
          onWorkflowRemoved={handleWorkflowRemoved}
          onCourseAdded={() => refresh()}
          onDateRangeChange={() => refresh() }
          stepId={stepId}
        />
      )}
    </>
  );
}

const Workflows = ({ selectedProjectDetail, setActiveModal, setFaseModal, pageType, removeCourse, formatDisplayDate, setstepId, setdates }) => {
  const navigationContext = useContext(PageContext);
  const steps = selectedProjectDetail?.steps || selectedProjectDetail || [];
  
  const handleDateUpdate = (step) => {
  setActiveModal("dateRange");
  setFaseModal(true);
  setdates({ start: step.start_date, end: step.end_date });
  setstepId(step.id_step);
  };

  const handleAddButton = (step) => {
    setstepId(step.id_step);
    setActiveModal("courses");
    setFaseModal(true);
  };
  
  return (  
    <>
    {steps.some((step) => step.courses?.length > 0) && (
      steps.map((step) => (
        <StandardComp
          style={{ marginLeft: "1.5rem"}}
          editClass={"standard-margin-bottom standard-shadow"}
          key={step.id_step}
          content={
            <>              
              <StepHeader setActiveModal={setActiveModal} setFaseModal={setFaseModal} formatDisplayDate={formatDisplayDate} step={step} setStepId={setstepId} handleDateUpdate={handleDateUpdate} />
                <CourseLayout>
                <CourseCards courses={step.courses} pageType={pageType} onRemoveCourse={removeCourse} stepId={step.id_step} navigationContext={navigationContext} />
                <AddButton onClick={() => handleAddButton(step)} />
              </CourseLayout>
            </>
          }
        />
    )))}
      { selectedProjectDetail && <AddStepButton onClick={() => { setActiveModal("addStep"); setFaseModal(true)}} title="Een nieuwe workflow stap aanmaken" />} 
      </>
  );
};

const courseContext = ( navigationContext, course ) =>{
  return(
      navigationContext.handleNavigation({
      courseID: course.id_course,
      navigation: 7,
      enrollment: 0,
    })
  )
}

const CourseCards = ({ courses = [], navigationContext, pageType, onRemoveCourse, stepId}) => {

  return courses
    .filter((course) => course && course.id_course != null)
    .map((course) => {

      return (
        <CourseComp
          key={course.id_course}
          pageType={pageType}
          removeCourseId={course.id_course}
          onRemoveCourse={onRemoveCourse}
          stepId={stepId}
          costumColumnsTemplate="0.2fr 1fr auto auto"
          style={{ gridTemplateColumns: "repeat(3, 1fr)"}}
          onClick={() =>courseContext(navigationContext, course)}
          title={course.title || "Untitled Course"}
          duration={course.duration || "0m"}
          lessons={course.lessonCount || 0}
          image={course.image_url || ""}
          AI={course.ai_mode === 1}
          error={course.ai_mode === 4}
        />
      );
    });    
  };

const AddButton = ({ onClick, style, size = 50 }) => {
    return (
      <div className="workflow-add-btn" onClick={onClick} style={style}>
        <IconButton
          style={{
            color: "var(--primary-500)",
            backgroundColor: "transparent",
          }}
          color="icon-spin"
          icon2="plus"
          size={size}
        />
      </div>
    );
  };

const DeleteButton = ({ onClick , style }) => {
    return (
      <div style={style} onClick={onClick}>
        <IconText
          style={{
            color: "var(--primary-500)",
            backgroundColor: "transparent",
          }}
          backgroundColor="var(--error-100)"
          iconColor={"var(--error-600)"}
          tooltipBackground={"var(--error-600)"}
          label={""}
          tooltip={"Verwijderen"}
          icon2={"trash"}
          size={50}
          color={"icon-spin"}
          tooltipLocation={"center"}
          marginBottom={"0.7rem"}
        />
      </div>
    );
  };
  
const AddStepButton = ({ onClick, title }) => {
    return(
      <HorizontalLayout onClick={onClick} className = "workflow-add-btn" style={{
          margin: "1.5rem",
          minHeight: "2.5rem",
          width: "auto",
          gap: "0.50rem",
          color: "var(--primary-500)",
        }} >
        <IconButton
          color="icon-spin"
          icon2="plus"
          size={30}
          style={{
            color: "var(--primary-500)",
          }}
        />
        <TextAtom title= {title} />
        </HorizontalLayout>
    )
  };

const StepHeader = ({ setActiveModal, setFaseModal, formatDisplayDate, step, today, setStepId, handleDateUpdate, isPublic}) => {  
    return (
      <HorizontalLayout className="space-between">
        <DeleteButton onClick={() => { setStepId(step.id_step); setActiveModal("deleteStep"); setFaseModal(true);}} />
        <TitleDescriptionText
          className="space-between horizontal"
          style={{ marginTop: "0", marginBottom: "0", paddingTop: "0", paddingLeft: "0.5rem"}}
          title={`${formatDisplayDate(step.start_date ?? today )}  ${!isPublic ? `→ ${formatDisplayDate(step.end_date ?? today)}`: "" }`}
          description={!isPublic ? `${step.courses?.filter(c => c)?.length || 0} cursussen` : undefined}
          editable={true}
          onClick={() => handleDateUpdate(step)}
        />
      </HorizontalLayout>
    )
  };

const CourseLayout = ({ children }) => {
    return (
      <GridLayout
        className="course-grid"
        style={{ marginTop: "0", marginBottom: "0", paddingTop: "0" }}
        gap="16px"
        columnsTemplate= {"repeat(4, 1fr)"}
      >
        {children}
      </GridLayout>                
    )
  };

